import { useCallback } from 'react';
import { useToast } from '@/hooks/use-toast';

type AcceptanceType = 'privacyPolicy' | 'termsOfUse';

interface AcceptanceRecord {
  accepted: boolean;
  timestamp: string;
}

interface AcceptanceStorage {
  privacyPolicy?: AcceptanceRecord;
  termsOfUse?: AcceptanceRecord;
}

const STORAGE_KEY = 'aceena_legal_acceptance';

export const useAcceptanceLog = () => {
  const { toast } = useToast();

  const logAcceptance = useCallback((type: AcceptanceType, documentName: string) => {
    const timestamp = new Date().toISOString();
    
    // Log to console for debugging/auditing
    console.log(`[Aceena Legal Acceptance] ${documentName} aceito em ${timestamp}`);
    
    // Get existing records
    const existingData = localStorage.getItem(STORAGE_KEY);
    const records: AcceptanceStorage = existingData ? JSON.parse(existingData) : {};
    
    // Update with new acceptance
    records[type] = {
      accepted: true,
      timestamp
    };
    
    // Save to localStorage
    localStorage.setItem(STORAGE_KEY, JSON.stringify(records));
    
    // Show confirmation toast
    toast({
      title: "Aceite registrado",
      description: `Você aceitou ${documentName} em ${new Date(timestamp).toLocaleString('pt-BR')}.`,
    });
    
    return timestamp;
  }, [toast]);

  const getAcceptanceStatus = useCallback((type: AcceptanceType): AcceptanceRecord | null => {
    const existingData = localStorage.getItem(STORAGE_KEY);
    if (!existingData) return null;
    
    const records: AcceptanceStorage = JSON.parse(existingData);
    return records[type] || null;
  }, []);

  return { logAcceptance, getAcceptanceStatus };
};
